import { render, staticRenderFns } from "./AreaDetalhes.vue?vue&type=template&id=03dd101a"
import script from "./AreaDetalhes.vue?vue&type=script&lang=js"
export * from "./AreaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports